import React, { useEffect, useState } from 'react';
import CheckCircleIcon from '../../../../../Assets/Icons/check-circle.svg';
import { CircularProgress } from '@mui/material';

const ChatbotSidePanelLoading = () => {
  const [processingSteps, setProcessingSteps] = useState([
    { label: "Reading your input", completed: false },
    { label: "Understanding your style", completed: false },
    { label: "Planning your timeline", completed: false },
    { label: "Estimating your wedding budget", completed: false },
    { label: "Finalizing your plan", completed: false },
  ])

  useEffect(() => {
    let currentIndex = -1;
    const intervalDuration = 1500;

    const interval = setInterval(() => {
      currentIndex = currentIndex + 1;

      if (currentIndex >= 6) {
        clearInterval(interval);
        return;
      }

      setProcessingSteps(prevSteps => 
        prevSteps.map((step, index) => {
          return {
            ...step,
            completed: index < currentIndex
          }
        })
      );
      
    }, intervalDuration);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-steps-container">
      <div className="loading-steps">
        {processingSteps.map((step, index) => (
          <div key={index} className="loading-step">
            <div className={`loading-step-circle ${step.completed ? "completed" : ""}`}>
              {step.completed ? (
                <img src={CheckCircleIcon} alt="Check Circle" />
              ) : (
                <div className="loading-step-circle-inner"></div>
              )}
            </div>
            <div className="loading-step-label">{step.label}</div>
          </div>
        ))}
        
        {/* grey line */}
        <div className="loading-step-line"/>

        {/* active line */}
        <div 
          className="loading-step-line-active" 
          style={{height: `${(processingSteps.filter((step, idx) => step.completed && idx < processingSteps.length - 1).length / (processingSteps.length - 1)) * 100}%`}}
        />
      </div>

      <div style={{width: 320, marginTop: 32}}>
        <div className="loading-progress-bar">
          <div
            className="loading-progress-bar-inner"
            style={{
              width: `${(processingSteps.filter((step) => step.completed).length / processingSteps.length) * 100}%`,
            }}
          ></div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 24 }}>
          <CircularProgress size={32} />
        </div>

        <p style={{color: `rgb(107 114 128)`, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          {processingSteps.find((step) => !step.completed)?.label || "Finalizing..."}
        </p>
      </div>
    </div>
  )
}

export default ChatbotSidePanelLoading;


